import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout/layout';
import Seo from '../components/seo';
import useLanguage from '../hooks/useLanguage';

import {
  AboutMainScreen,
  Video,
  DefaultInfo,
  CrumbsNav,
  DownloadPdf,
  FreeLesson,
  AboutApproach,
  Quote,
  Ticker,
  AboutServices,
  AboutFounder,
} from '../components/Pages/About';

import { aboutStatic } from '../db/aboutStatic';

const aboutPage = ({ data }) => {
  const aboutDatas = data.strapiAbout;
  const langToggle = useLanguage;

  return (
    <Layout>
      <Seo
        title={langToggle(aboutDatas.seo_title_ua, aboutDatas.seo_title_ru)}
        description={langToggle(
          aboutDatas.seo_description_ua,
          aboutDatas.seo_description_ru
        )}
        keywords={[
          langToggle(aboutDatas.seo_keywords_ua, aboutDatas.seo_keywords_ru),
        ]}
      />
      <AboutMainScreen mainData={aboutDatas.about_main} />
      <Video videoData={aboutDatas.about_video} />
      <DefaultInfo aboutSchoolData={aboutDatas.about_school} />
      <AboutApproach approachData={aboutDatas.approach} />
      <DefaultInfo aboutSchoolData={aboutDatas.method} />
      <Quote quoteData={aboutDatas.Quotes} />
      <Ticker tickerData={aboutDatas.ticker} />
      <AboutServices
        servicesData={aboutDatas.about_services}
        servicesCategory={data.strapiHome.home_services}
      />
      <DownloadPdf downloadPdfData={aboutDatas.about_guides} />
      <AboutFounder founderData={aboutDatas.Founder} />
      <FreeLesson freeLessonData={aboutDatas.trial_lesson} />
      <CrumbsNav crumbsData={aboutStatic.crumbs_nav} />
    </Layout>
  );
};

export default aboutPage;

export const query = graphql`
  query About($language: String!) {
    strapiAbout {
      seo_title_ua
      seo_title_ru
      seo_description_ua
      seo_description_ru
      seo_keywords_ua
      seo_keywords_ru
      about_main {
        title_01_ua
        title_02_ua
        title_03_ua
        title_01_ru
        title_02_ru
        title_03_ru
        description_ua
        description_ru
      }
      about_video {
        video_ua
        video_ru
        cover {
          localFile {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
            }
          }
        }
      }
      about_school {
        marker_ua
        marker_ru
        title_ua
        title_ru
        description_ua
        description_ru
      }
      approach {
        marker_ua
        marker_ru
        title_ua
        title_ru
        items {
          title_ua
          title_ru
        }
      }
      method {
        marker_ua
        marker_ru
        title_ua
        title_ru
        description_ua
        description_ru
      }
      Quotes {
        quote_ua
        quote_ru
      }
      ticker {
        id
        ticker_ua
        ticker_ru
      }
      about_services {
        marker_ua
        marker_ru
        title_ua
        title_ru
        services {
          title_ua
          title_ru
          link
          description_ua
          description_ru
        }
      }
      about_guides {
        marker_ua
        marker_ru
        title_ua
        title_ru
        pdf_ua {
          url
        }
        # pdf_ru {
        #   url
        # }
      }
      Founder {
        marker_ua
        marker_ru
        title_ua
        title_ru
        about_founder {
          marker_ua
          marker_ru
          title_ua
          title_ru
          description_ua
          description_ru
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
            }
          }
        }
        quote_ua
        quote_ru
        history_marker_ua
        history_marker_ru
        history_ua
        history_ru
        approach_marker_ua
        approach_marker_ru
        approach_ua
        approach_ru
      }
      trial_lesson {
        title_ua
        title_ru
      }
    }
    strapiHome {
      home_services {
        Services {
          title_ua
          title_ru
          description_ua
          description_ru
          link
        }
      }
    }
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
